// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root__1KS0i"};